import React, { useEffect, useState } from 'react';

const TemplateSelector = ({
  templates,
  selectedTemplate,
  handleTemplateChange,
  loadingTemplates,
  error,
}) => {
  const [defaultTemplate, setDefaultTemplate] = useState(null);

  // Sätt en standardmall när mallar har laddats
  useEffect(() => {
    if (templates.length > 0 && !selectedTemplate) {
      const firstTemplate = templates[0]; // Första mallen som standard
      setDefaultTemplate(firstTemplate.template_id.toString());
      handleTemplateChange(firstTemplate.template_id.toString()); // Informera parent
    }
  }, [templates, selectedTemplate, handleTemplateChange]);

  return (
    <div className="template-selector">
      {loadingTemplates ? (
        <p>Hämtar mallar...</p>
      ) : error ? (
        <p className="error-message">{error}</p>
      ) : (
        <>
          <label htmlFor="template-select">Välj mall:</label>
          <select
            id="template-select"
            value={
              selectedTemplate
                ? selectedTemplate.template_id.toString()
                : defaultTemplate || '' // Standardval om inget redan är valt
            }
            onChange={(e) => handleTemplateChange(e.target.value)}
            className="template-select"
          >
            {templates.map((template) => (
              <option key={template.template_id} value={template.template_id.toString()}>
                {template.template_name}
              </option>
            ))}
          </select>
        </>
      )}
    </div>
  );
};

export default TemplateSelector;
